// extracted by css-extract-rspack-plugin
export default {"feedbackBanner":"PromptFeedbackBanner-module__feedbackBanner__esU8d"};